const baseUrl = process.env.REACT_APP_BASE_URL;
export const createCheckInUrl = baseUrl + "check_ins";
